import IconLink from './IconLink';

export default IconLink;



// WEBPACK FOOTER //
// ./src/components/shared/IconLink/index.js